<template>
  <v-chip
    v-if="leadTime"
    class="lead-time-chip qtm-body-small"
    :class="info ? 'text-info-darken-1' : 'text-neutral-text'"
    :color="info ? 'info-lighten-1' : 'neutral-background'"
    density="compact"
    label
    variant="flat"
  >
    {{ leadTime }} lead
  </v-chip>
</template>

<script setup lang="ts">
export interface Props {
  info?: boolean
  leadTime?: string | null
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.lead-time-chip {
  font-weight: 500;
  height: 24px;
  padding-inline: 8px;
}

</style>
